import { MemberDocumentPresignedUrlPostSchema } from "../types/Document";
import { request } from "./request";

export async function getUrlForDownload(documentId: number, enrollmentPlanId: number, target: "download" | "view"): Promise<MemberDocumentPresignedUrlPostSchema> {
  return await request({
    url: "/document/url_for_download",
    method: "POST",
    data: {
      id: documentId,
      enrollment_plan_id: enrollmentPlanId,
      user_target: target,
    },
  });
}
